import { FunctionComponent, useState } from 'react';
import { SectionTitle } from '../shared-components/SectionTitle';
import { DeliveryUpdateListItem } from './DeliveryUpdateListItem';
import * as styles from './DeilveryUpdateTable.module.scss';

export type DeliveryUpdateItem = {
  description: string;
  location: string;
  subtext: string;
  statusName:
    | 'delivered'
    | 'outForDelivery'
    | 'inTransit'
    | 'packageShipped'
    | 'processingShipment'
    | 'error';
};

export type DeliveryUpdateTableProps = {
  statuses: Array<DeliveryUpdateItem>;
};

export const DeliveryUpdateTable: FunctionComponent<DeliveryUpdateTableProps> = ({ statuses }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const handleToggleDrawer = () => {
    setIsDrawerOpen((prevState) => !prevState);
  };

  return (
    <div className={styles.container}>
      <SectionTitle
        title="Delivery Updates"
        isDrawerOpen={isDrawerOpen}
        handleToggleDrawer={handleToggleDrawer}
      />
      {isDrawerOpen && (
        <ul>
          {statuses.map((status: DeliveryUpdateItem, index: number) => (
            <DeliveryUpdateListItem
              key={index}
              index={index}
              statusName={status.statusName}
              description={status.description}
              location={status.location}
              subtext={status.subtext}
            />
          ))}
        </ul>
      )}
    </div>
  );
};
